import React from 'react';
import {
  LBTooltipProvider,
  LBTooltip,
  LBTooltipTrigger,
  LBTooltipContent,
  LBFlameIcon,
  LBBenchmarkIndication
} from '@linearb/buzz';

const Burnout = ({ name, isWipOverload, isTopReviewer, showLabel = true }) => {
  const showBurnoutText = showLabel && !isTopReviewer && !isWipOverload;
  return (
    <>
      {showBurnoutText && (
        <div className='pr-2 text-sm' data-testid='Burnout-text'>
          Burnout risk
        </div>
      )}
      <LBTooltipProvider key={name}>
        <LBTooltip>
          <LBTooltipTrigger className='overflow-hidden text-ellipsis'>
            <LBBenchmarkIndication variant='poor' size='sm'>
              <LBFlameIcon />
            </LBBenchmarkIndication>
          </LBTooltipTrigger>
          <LBTooltipContent>
            <div className='flex flex-col gap-1'>
              <div className='flex items-center gap-2'>Burnout Alert!</div>
              Is {name} taking time to rest? Check in with them.
            </div>
          </LBTooltipContent>
        </LBTooltip>
      </LBTooltipProvider>
    </>
  );
};

export default Burnout;
